export const DELETE_ADMIN_QUESTION_REQUEST = " DELETE_ADMIN_QUESTION_REQUEST";
export const DELETE_ADMIN_QUESTION_SUCCESS = " DELETE_ADMIN_QUESTION_SUCCESS";
export const DELETE_ADMIN_QUESTION_FAILURE = " DELETE_ADMIN_QUESTION_FAILURE";
